<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-card-title
        class="d-flex justify-lg-space-between"
        style="border-bottom: 2px solid #dfe2e9"
      >
        <span>
          {{ $t("importFromExcel") }}
        </span>
        <VBtn @click="close" style="background-color: #fff">
          <v-icon color="lightGrey">mdi-close</v-icon>
        </VBtn>
      </v-card-title>
      <v-card-text>
        <v-list dense>
          <div class="d-flex flex-column mt-3">
            <span style="color: #a2a5b9; font-size: 12px; font-weight: 400">
              {{ $t("warehouse") }} :</span
            >
            <span style="color: #48545d; font-size: 18px; font-weight: 600">
              {{ warehouse.name }}
            </span>
          </div>
        </v-list>
        <validation-observer v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(submit)">
            <v-switch
              :label="$t('used')"
              hide-details
              v-model="warehouse.used"
              style="margin: 20px 0px"
            ></v-switch>
            <validation-provider
              tag="div"
              class="pt-3"
              :name="$t('file')"
              rules="required"
              v-slot="{ errors }"
            >
              <v-file-input
                v-model="warehouse.file"
                :error-messages="errors[0]"
                label="Exel.excl"
                clearable
              />
            </validation-provider>
            <div class="text-right">
              <VBtn
                :loading="loading"
                style="width: 100%; margin-top: 20px"
                color="primary"
                type="submit"
                >{{ $t("send") }}
              </VBtn>
            </div>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const WAREHOUSE = {
  name: null,
  warehouseId: null,
  used: false,
  file: null,
};
export default {
  name: "WarehouseImportProductDialog",
  data() {
    return {
      loading: false,
      dialog: false,
      warehouse: {
        ...WAREHOUSE,
      },
    };
  },
  methods: {
    async submit() {
      const formData = new FormData();
      const { used, file, warehouseId } = this.warehouse;
      formData.append("file", file);
      formData.append("warehouseId", warehouseId);
      formData.append("used", used);
      this.loading = true;
      try {
        await this.$http.post("product-item/import-excel", formData);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    open(warehouse) {
      this.dialog = true;
      this.warehouse = {
        ...WAREHOUSE,
        ...warehouse,
      };
    },
    close() {
      const { formObs } = this.$refs;
      this.dialog = false;
      this.warehouse = { ...WAREHOUSE };
      if (formObs) formObs.reset();
    },
  },
};
</script>

<style scoped>
.d-flex.justify-lg-space-between .v-btn {
  box-shadow: none !important;
}
</style>
